import { PortfolioSectorExposureNames } from "@ctypes";
import { i18n, Translations } from "@i18n";

export const sectorContent: Record<PortfolioSectorExposureNames, string> = {
  [PortfolioSectorExposureNames.BusinessServices]: i18n.t(
    Translations.PorfolioSectorBusinessServices,
  ),
  [PortfolioSectorExposureNames.CommunicationServices]: i18n.t(
    Translations.PorfolioSectorCommunicationServices,
  ),
  [PortfolioSectorExposureNames.ConsumerDiscretionary]: i18n.t(
    Translations.PorfolioSectorConsumerDiscretionary,
  ),
  [PortfolioSectorExposureNames.ConsumerServices]: i18n.t(
    Translations.PorfolioSectorConsumerServices,
  ),
  [PortfolioSectorExposureNames.ConsumerStaples]: i18n.t(
    Translations.PorfolioSectorConsumerStaples,
  ),
  [PortfolioSectorExposureNames.Crypto]: i18n.t(Translations.PorfolioSectorCrypto),
  [PortfolioSectorExposureNames.Energy]: i18n.t(Translations.PorfolioSectorEnergy),
  [PortfolioSectorExposureNames.Etf]: i18n.t(Translations.PorfolioSectorEtf),
  [PortfolioSectorExposureNames.Fiat]: i18n.t(Translations.PorfolioSectorFiat),
  [PortfolioSectorExposureNames.Financials]: i18n.t(Translations.PorfolioSectorFinancials),
  [PortfolioSectorExposureNames.FixedIncome]: i18n.t(Translations.PorfolioSectorFixedIncome),
  [PortfolioSectorExposureNames.HealthCare]: i18n.t(Translations.PorfolioSectorHealthCare),
  [PortfolioSectorExposureNames.Industrials]: i18n.t(Translations.PorfolioSectorIndustrials),
  [PortfolioSectorExposureNames.InformationTechnology]: i18n.t(
    Translations.PorfolioSectorInformationTechnology,
  ),
  [PortfolioSectorExposureNames.Materials]: i18n.t(Translations.PorfolioSectorMaterials),
  [PortfolioSectorExposureNames.Other]: i18n.t(Translations.PorfolioSectorOther),
  [PortfolioSectorExposureNames.RealEstate]: i18n.t(Translations.PorfolioSectorRealEstate),
  [PortfolioSectorExposureNames.Utilities]: i18n.t(Translations.PorfolioSectorUtilities),
  [PortfolioSectorExposureNames.MoneyMarket]: i18n.t(Translations.PortfolioSectorMoneyMarket),
};
